<template>
  <div class="app-container">
    <el-row type="flex" justify="center" align="middle">
      <h2>AI 标签生成器</h2>
    </el-row>
    <el-row type="flex" justify="center" :gutter="20">
      <el-col :span="10">
        <el-form
          ref="form"
          :model="form"
          label-position="right"
          label-width="100px"
        >
          <el-form-item label="正向标签">
            <el-input
              v-model="form.prompt"
              type="textarea"
              :rows="10"
              placeholder="Prompt"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" plain @click="copyPrompt" class="copyBtn"
              >复制</el-button
            >
            <el-button type="warning" plain @click="clearPrompt"
              >清空</el-button
            >
            <el-button plain @click="defaultPrompt">默认</el-button>
            <el-button
              type="danger"
              plain
              v-if="setting.adult"
              @click="adultPrompt"
              >成人默认</el-button
            >
          </el-form-item>
          <el-form-item label="反向标签">
            <el-input
              v-model="form.negative_prompt"
              type="textarea"
              :rows="10"
              placeholder="Negative Prompt"
            />
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              plain
              @click="copyNegativePrompt"
              class="copyBtn"
              >复制</el-button
            >
            <el-button type="warning" plain @click="clearNegativePrompt"
              >清空</el-button
            >
            <el-button plain @click="defaultNegativePrompt">默认</el-button>
            <el-button
              type="danger"
              plain
              v-if="setting.adult"
              @click="adultNegativePrompt"
              >成人默认</el-button
            >
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="14">
        <el-steps simple>
          <el-switch v-model="setting.en" inactive-text="英文" disabled />
          <el-switch v-model="setting.zh" inactive-text="中文" />
          <el-switch v-model="setting.down" inactive-text="降权" />
          <el-switch v-model="setting.up" inactive-text="加权" />
          <!-- <el-switch v-model="setting.del" inactive-text="删除" /> -->
          <el-switch v-model="setting.adult" inactive-text="成年" />
        </el-steps>
        <el-tabs
          tabPosition="left"
          :activeName="activeName"
          style="height: 600px; background: var(--el-fill-color-light);"
        >
          <el-tab-pane
            :label="item.name"
            :name="item.processName"
            v-for="item in promptList"
            :key="item.id"
          >
            <div class="app-container" style="height: 600px;overflow-y: auto;">
              <span v-for="(prompt, index) in item.subAiPrompt" :key="index">
                <span v-if="prompt.type != 7 || setting.adult">
                  <el-divider content-position="left">{{
                    prompt.name
                  }}</el-divider>
                  <span
                    v-for="(subItem, subIndex) in prompt.subAiPrompt"
                    :key="subIndex"
                    class="prompt"
                  >
                    <el-button
                      type="warning"
                      v-if="setting.down"
                      @click="downWeight(subItem)"
                      plain
                      icon="el-icon-remove-outline"
                    >
                      <!-- <el-icon><Remove /></el-icon> -->
                    </el-button>
                    <el-button
                      type="warning"
                      v-if="setting.up"
                      @click="upWeight(subItem)"
                      plain
                      icon="el-icon-circle-plus-outline"
                    >
                      <!-- <el-icon><CirclePlus /></el-icon> -->
                    </el-button>
                    <el-button @click="selectPrompt(subItem)" plain>
                      <span v-if="setting.en">{{ subItem.enText }}</span>
                      <span v-if="setting.zh">「{{ subItem.zhText }}」</span>
                    </el-button>
                  </span>
                </span>
              </span>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>

<script>
// import { ElMessage } from 'element-plus'
import Clipboard from 'clipboard'

// import Basic from '../components/Basic.vue'
// import Environment from '../components/Environment.vue'
// import Style from '../components/Style.vue'
// import Character from '../components/Character.vue'
// import Hair from '../components/Hair.vue'
// import Face from '../components/Face.vue'
// import Hand from '../components/Hand.vue'
// import Chest from '../components/Chest.vue'
// import Foot from '../components/Foot.vue'
// import Dress from '../components/Dress.vue'
// import Action from '../components/Action.vue'
import API from "@/api";

export default {
  name: "Home",
  components: {
    // Basic,
    // Environment,
    // Style,
    // Character,
    // Hair,
    // Face,
    // Hand,
    // Chest,
    // Foot,
    // Dress,
    // Action
  },
  data() {
    return {
      promptList: [],
      activeName: "",
      prompt:
        "masterpiece, best quality, top quality, ultra highres, 8k hdr, 8k wallpaper, huge file size, intricate details, sharp focus, realistic, delicate, amazing, CG, finely detailed, beautiful detailed, colourful, ",
      negative_prompt:
        "lowres, bad anatomy, bad hands, text, error, missing fingers, extra digit, fewer digits, cropped, worst quality, low quality, normal quality, jpeg artifacts, signature, watermark, username, blurry, bad feet, ",
      adult_prompt:
        "masterpiece, best quality, top quality, ultra highres, 8k hdr, 8k wallpaper, huge file size, intricate details, sharp focus, realistic, delicate, amazing, CG, finely detailed, beautiful detailed, colourful, humiliation, partially unbuttoned, realistic, photo, real, {{breasts out}}, {{large breasts}}, no bra, no_panties, undressing, skirt lift, shirt lift, middle_nipples, leash, ",
      adult_negative_prompt:
        "worst quality, low quality, normal quality, ugly, bad_anatomy, bad_hands, extra_hands, missing_fingers, broken hand, more than two hands,well proportioned hands, more than two legs, unclear eyes, missing_arms, mutilated, extra limbs, extra legs, cloned face, fused fingers,extra_digit, ewer_digits, extra_digits, fewer digits, jpeg_artifacts, text, error, signature, watermark, username, blurry, worst_quality, low_quality, normal_quality, mirror image, Vague, paintings, sketches, (worst quality:2), (low quality:2), (normal quality:2), lowres, normal quality, ((monochrome)), ((grayscale)), skin spots, acnes, skin blemishes, age spot, cropped, bad feet, ",
      setting: {
        en: true,
        zh: false,
        down: false,
        up: false,
        del: false,
        cut: false,
        adult: false,
      },
      form: {
        prompt: "",
        negative_prompt: "",
      },
    };
  },
  created() {
    this.form.prompt = this.prompt;
    this.form.negative_prompt = this.negative_prompt;
    this.queryAllPrompt();
  },
  methods: {
    // 查询所有提示词
    queryAllPrompt() {
      API.queryAllPrompt().then((res) => {
        if (res.code === 200 && res.data) {
          this.promptList = res.data || [];
          console.log(res.data);
          // this.promptList.forEach(item => {

          // })
          if (this.promptList.length) {
            this.activeName = this.promptList[0].processName;
          }
        }
      });
    },
    defaultPrompt() {
      this.form.prompt = this.prompt;
    },
    clearPrompt() {
      this.form.prompt = "";
    },
    adultPrompt: function() {
      this.form.prompt = this.adult_prompt;
    },
    clearNegativePrompt() {
      this.form.negative_prompt = "";
    },
    defaultNegativePrompt: function() {
      this.form.negative_prompt = this.negative_prompt;
    },
    adultNegativePrompt: function() {
      this.form.negative_prompt = this.adult_negative_prompt;
    },
    copyPrompt: function() {
      
      let that = this
      let clipboard = new Clipboard('.copyBtn', {
        text: function () {
          //返回要复制的文本
          return that.form.prompt
        }
      })
      clipboard.on('success', () => {
        this.$message.success('复制成功')
        //释放内存
        clipboard.destroy()
      })
      clipboard.on('error', () => {
        this.$message.error('复制失败');
        //释放内存
        clipboard.destroy()
      })
    },
    copyNegativePrompt: function() {
      let that = this
      let clipboard = new Clipboard('.copyBtn', {
        text: function () {
          //返回要复制的文本
          return that.form.negative_prompt
        }
      })
      clipboard.on('success', () => {
        this.$message.success('复制成功')
        //释放内存
        clipboard.destroy()
      })
      clipboard.on('error', () => {
        this.$message.error('复制失败');
        //释放内存
        clipboard.destroy()
      })
    },
    downWeight(item) {
      let text = item.enText;
      if (text.startsWith("(") && text.endsWith(")")) {
        item.enText = text.substring(1, text.length - 1);
      } else {
        item.enText = `[${text}]`;
      }
    },
    upWeight(item) {
      let text = item.enText;
      if (text.startsWith("[") && text.endsWith("]")) {
        item.enText = text.substring(1, text.length - 1);
      } else {
        item.enText = `(${text})`;
      }
    },
    selectPrompt(item) {
      // let prompt = $event.currentTarget.firstElementChild.firstElementChild;
      // console.log($event)
      this.form.prompt += item.enText + ", ";
      // let prompt = $event.currentTarget.firstElementChild.firstElementChild;
      // this.$emit("updateSelect", prompt.innerText);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-switch {
  margin: 0 1rem;
}

.el-button {
  margin-left: 0.2rem;
  margin-bottom: 0.5rem;
}

.prompt {
  margin: 2px;
}

.app-container {
  /deep/ .el-tabs {
    background: #f5f7fa !important;
  }
}
</style>
